export default "__VITE_ASSET__B8C2O$8d__"